__turbopack_context__.v({
  "actionRow": "index-module-scss-module__i9qUvG__actionRow",
  "actionRowBtns": "index-module-scss-module__i9qUvG__actionRowBtns",
  "collapsed": "index-module-scss-module__i9qUvG__collapsed",
  "desc": "index-module-scss-module__i9qUvG__desc",
  "expanded": "index-module-scss-module__i9qUvG__expanded",
  "introWrapper": "index-module-scss-module__i9qUvG__introWrapper",
  "more": "index-module-scss-module__i9qUvG__more",
  "moreDesktop": "index-module-scss-module__i9qUvG__moreDesktop",
  "moreInline": "index-module-scss-module__i9qUvG__moreInline",
  "us": "index-module-scss-module__i9qUvG__us",
  "view": "index-module-scss-module__i9qUvG__view",
});
